<!-- 基础数据-响应式表单 -->
<form nz-form [formGroup]="formGroup" (ngSubmit)="submitForm()" [nzLayout]="'inline'" *ngIf="listOfOption">
  <nz-form-item style="width: 23.5%;margin-bottom: 10px;" *ngFor="let item of formItems">
    <nz-form-label class="title">{{ item.text | translate }}</nz-form-label>
    <nz-form-control class="value">
      <!-- 下拉内容 -->
      <nz-select nzShowSearch nzAllowClear [formControlName]="item.value">
        <nz-option *ngFor="let selectValue of listOfOption[item.value]" [nzValue]="selectValue" [nzLabel]="selectValue" style="text-overflow:ellipsis;">
          {{ selectValue }}
        </nz-option>
      </nz-select>
    </nz-form-control>
  </nz-form-item>
</form>